module.exports = __webpack_public_path__ + "img/pencil.7183b7ad.svg";